export const environment = {
  production: false,

  baseUrl: `https://homologapremocenterback.grupoagtech.com/api/`,
  baseUrlPremocenter: `https://homologapremocenter.grupoagtech.com`,
  baseUrlPremoplan: `https://homologapremoplan.grupoagtech.com/index`,
  baseUrlHidrometer: 'https://hidrometerbeta.grupoagtech.com/hidrometer/index',
  baseUrlHidrometerV3: 'https://hidrometerbeta.grupoagtech.com/index',
  baseUrlBackendHidrometer: 'https://homologahidrometerback.grupoagtech.com/api/',
  baseUrlCronosBack: 'https://homologacronosservice.grupoagtech.com/api/',
  baseUrlTopes: 'https://homologatopes.grupoagtech.com/index',
  baseUrlCronosDashboard: 'https://homologacronosdashboard.grupoagtech.com/index',
  baseUrlPremovin: 'https://homologapremovin.grupoagtech.com/index',

  MAPBOX_TOKEN: 'pk.eyJ1IjoiZ2lvdmFuYWl3YW1penUiLCJhIjoiY2xnZmh6NzA1MDFzeTNsbmQzMHA5aHRidyJ9.cjsUInyuZ6jb8PPdvzq8sQ',

  recaptcha: {
    siteKey: '6LfdatwdAAAAABEZHj2oxzMDvVpcoNGKtCyNBpDJ',
  },
  hotjarId: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
